import Cookies from 'js-cookie'

const SESSION_COOKIE = 'csm_light_session'
const COOKIE_OPTIONS = { expires: 1, path: '/', sameSite: 'Lax' }

const LICENSE_PLATE_PATTERN = /^(([a-z]{3}\d{3})|([a-z]{2}\d{3}[a-z]{2})|((cd|cc|oi|me|pa)\d{4})|((d|c|i|m|a)\d{3}[a-z]{3})|(\d{3}[a-z]{3})|([a-z]\d{3}[a-z]{3}))$/i

export const normalizePlate = (plate) => {
    if (!plate) {
        return null
    }

    const compact = String(plate).replace(/[\s-]/g, '').toUpperCase()

    return compact || null
}

/** Quita el sufijo de endoso (ej. "12345/6" → "12345") para URLs y búsqueda en autogestión. */
export const normalizePolicyNumber = (policyNumber) => {
    if (policyNumber === null || policyNumber === undefined || policyNumber === '') {
        return null
    }

    const trimmed = String(policyNumber).trim()
    const slashIndex = trimmed.indexOf('/')

    if (slashIndex === -1) {
        return trimmed || null
    }

    const baseNumber = trimmed.slice(0, slashIndex).trim()

    return baseNumber || null
}

export const extractPlateFromAsset = (asset) => {
    if (!asset) {
        return null
    }

    const parts = String(asset).split(',').map((item) => item.trim()).filter(Boolean)

    if (parts.length < 2) {
        return null
    }

    const compact = parts[parts.length - 1].replace(/\s/g, '')

    if (!LICENSE_PLATE_PATTERN.test(compact)) {
        return null
    }

    return compact.toUpperCase()
}

export const getLightSession = () => {
    try {
        const raw = Cookies.get(SESSION_COOKIE)

        if (!raw) {
            return null
        }

        const parsed = JSON.parse(raw)

        if (!parsed?.identityNumber) {
            return null
        }

        return {
            identityNumber: parsed.identityNumber,
            plate: normalizePlate(parsed.plate),
            policyNumber: normalizePolicyNumber(parsed.policyNumber),
        }
    } catch (error) {
        return null
    }
}

export const saveLightSession = ({ identityNumber, plate, policyNumber } = {}) => {
    if (!identityNumber) {
        Cookies.remove(SESSION_COOKIE, { path: '/' })
        return
    }

    const current = getLightSession() || {}

    Cookies.set(SESSION_COOKIE, JSON.stringify({
        identityNumber,
        plate: plate === undefined ? (current.plate ?? null) : (normalizePlate(plate) || null),
        policyNumber: policyNumber === undefined
            ? (current.policyNumber ?? null)
            : normalizePolicyNumber(policyNumber),
    }), COOKIE_OPTIONS)
}

export const clearLightSession = () => {
    Cookies.remove(SESSION_COOKIE, { path: '/' })
}

export const withIdentityNumberQuery = (path, identityNumber, plate, policyNumber) => {
    if (!path) {
        return path
    }

    const [pathname, search = ''] = path.split('?')
    const params = new URLSearchParams(search)

    if (identityNumber) {
        params.set('identityNumber', identityNumber)
    }

    const normalizedPlate = normalizePlate(plate)

    // Un solo criterio en la URL: patente o póliza, no ambos.
    if (normalizedPlate) {
        params.set('plate', normalizedPlate)
        params.delete('policyNumber')
    } else if (policyNumber) {
        params.set('policyNumber', normalizePolicyNumber(policyNumber))
        params.delete('plate')
    } else {
        params.delete('plate')
        params.delete('policyNumber')
    }

    const query = params.toString()

    return query ? `${pathname}?${query}` : pathname
}
